import api from './api'

export const DefaultApi = api(process.env.BFF_URL, {})
